import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
const { formatText } = i18n;

const LeaveModal = ({ type = 'videoCall', name = '', onAccept, onCancel, tagView }) => {
    const titleKey = `identity-${type}LeaveTitle`;
    const infoKey = `identity-${type}LeaveConfirmation`;
    useEffect(() => {
        tagView();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <React.Fragment>
            <br />
            <h3 className="font-heading3">{formatText(titleKey, [name])}</h3>
            <div className="video-screen__modal-body-content">
                <p className="video-screen__modal-body-text font-paragraph2">{formatText(infoKey)}</p>
            </div>
            <div className="video-screen__modal-buttons video-screen__modal-buttons--more-one">
                <button className="form__button form__button-clean" onClick={onAccept}>
                    {formatText('button-leave')}
                </button>
                <button className="form__button form__button-secondary" onClick={onCancel}>
                    {formatText('button-stayHere')}
                </button>
            </div>
        </React.Fragment>
    );
};

LeaveModal.propTypes = {
    onAccept: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    tagView: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};

export default LeaveModal;
